import { ManagementApi } from './api';

export interface PublishableSchedule {
  schedule_id: string;
  schedule_version: number;
  runtime_revision_id?: string;
  runtime_status?: string;
}

// Re-read before retrying so a successful preparation/publication whose response
// was lost does not create a second revision. Backend validation remains authoritative.
export async function publishSchedule(api: Pick<ManagementApi, 'get' | 'mutate'>, root: string, schedule: PublishableSchedule): Promise<void> {
  const schedules = await api.get<PublishableSchedule[]>(`${root}/game-sessions`);
  const latest = schedules.filter(s => s.schedule_id === schedule.schedule_id).sort((a,b) => b.schedule_version - a.schedule_version)[0];
  if (!latest || latest.schedule_version !== schedule.schedule_version) throw new Error('The session changed. Refresh the list before publishing.');
  if (latest.runtime_status === 'published') return;
  const revision = latest.runtime_status === 'draft' && latest.runtime_revision_id
    ? latest.runtime_revision_id
    : (await api.mutate<{ session_revision_id: string }>(`${root}/game-sessions/${encodeURIComponent(schedule.schedule_id)}/prepare`, 'POST', { schedule_version: schedule.schedule_version })).session_revision_id;
  await api.mutate(`${root}/session-revisions/${encodeURIComponent(revision)}:publish`, 'POST');
}
